import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, TPropertiesOfPatchChangesForModGroup } from 'types';

export type TTypeOfModalWindow = Nullable<'toConfirmFieldsClearing' | 'error'>;

export interface ISaveAsPatchState {
	initialFormData: {
		modGroupId: string;
		customerName: string;
		inclusive: Nullable<number>;
		fetchedRestaurants: IItemForGetShortInfoWithStatus[];
		IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
		forceDisable: boolean;
	};
	typeOfChanges: 'basedChanges' | 'independentChanges';
	IDsSelectedRestaurant: string[];
	forceDisable: boolean;
	selectedProperties: TPropertiesOfPatchChangesForModGroup[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const saveAsPatchInitialState: ISaveAsPatchState = {
	initialFormData: {
		modGroupId: '',
		customerName: '',
		inclusive: null,
		fetchedRestaurants: [],
		IDSelectedRestaurantOnRestPropsPage: null,
		forceDisable: false,
	},
	typeOfChanges: 'basedChanges',
	IDsSelectedRestaurant: [],
	forceDisable: false,
	selectedProperties: [],
	typeOfModalWindow: null,
};

export interface ISaveAsPatchContext extends ISaveAsPatchState {
	saveData(value: 'saveAndMakeOtherChanges' | 'saveAndClose'): void;
	setTypeOfChanges(value: ISaveAsPatchState['typeOfChanges']): void;
	setIDsRestaurant(value: ISaveAsPatchState['IDsSelectedRestaurant']): void;
	setProperties: (value: ISaveAsPatchState['selectedProperties']) => void;
	toggleForceDisable(): void;
	changeTypeOfModalWindow(value: ISaveAsPatchState['typeOfModalWindow']): void;
}

export const SaveAsPatchContext = createContext<ISaveAsPatchContext>({
	saveData: () => undefined,
	setTypeOfChanges: () => undefined,
	setIDsRestaurant: () => undefined,
	setProperties: () => undefined,
	toggleForceDisable: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...saveAsPatchInitialState,
});
